<div class="tlr-health-container" *ngIf="!showResults">
    <h2>TLR Health</h2>

    <p-table [value]="formRows"  id="StyleTable">
        <ng-template pTemplate="body" let-row>
            <tr>
                <td class="label-cell">{{row.label}}</td>
                <td class="input-cell">
                    <!-- Date Range row -->
                    <ng-container *ngIf="row.type === 'date-range'">
                        <div class="date-row">
                            <span class="date-label">Start Date:</span>
                            <p-calendar [(ngModel)]="startDateObj" 
                                      dateFormat="m/d/yy"
                                      [showIcon]="true"
                                      (onSelect)="onStartDateSelect()"
                                      [style]="{'width':'200px'}"
                                      appendTo="body"></p-calendar>
                        </div>
                        <div class="date-row">
                            <span class="date-label">To Date:</span>
                            <p-calendar [(ngModel)]="toDateObj" 
                                      dateFormat="m/d/yy"
                                      [showIcon]="true"
                                      (onSelect)="onToDateSelect()"
                                      [style]="{'width':'200px'}"
                                      appendTo="body"></p-calendar>
                        </div>
                    </ng-container>

                    <!-- Process Name row -->
                    <ng-container *ngIf="row.type === 'process'">
                        <p-dropdown [options]="processOptions" [(ngModel)]="selectedProcess" 
                            optionLabel="label" optionValue="value" styleClass="full-width-dropdown"
                            [style]="{'width': '450px'}" (onChange)="onProcessSelected()"
                            appendTo="body" [scrollHeight]="'250px'" [autoDisplayFirst]="false" 
                            [autoZIndex]="true" [baseZIndex]="1000"></p-dropdown>
                    </ng-container>

                    <!-- Sub Process Name row -->
                    <ng-container *ngIf="row.type === 'sub-process'">
                        <p-dropdown [options]="subProcessOptions" [(ngModel)]="selectedSubProcess" 
                            optionLabel="label" optionValue="value" styleClass="full-width-dropdown"
                            [style]="{'width': '500px'}" 
                            appendTo="body" [scrollHeight]="'250px'" [autoDisplayFirst]="false"
                            [autoZIndex]="true" [baseZIndex]="1000"></p-dropdown>
                    </ng-container>

                    <!-- Status Code Indicator row -->
                    <ng-container *ngIf="row.type === 'status-indicator'">
                        <p-dropdown [options]="statusCodeIndicatorOptions" [(ngModel)]="selectedStatusCodeIndicator" 
                            optionLabel="label" optionValue="value" styleClass="medium-width-dropdown"
                            [style]="{'width': '450px'}" 
                            appendTo="body" [scrollHeight]="'250px'" [autoDisplayFirst]="false"
                            [autoZIndex]="true" [baseZIndex]="1000"></p-dropdown>
                    </ng-container>

                    <!-- Status Code row -->
                    <ng-container *ngIf="row.type === 'status-code'">
                        <p-dropdown [options]="statusCodeOptions" [(ngModel)]="selectedStatusCode" 
                            optionLabel="label" optionValue="value" styleClass="small-width-dropdown"
                            [style]="{'width': '400px'}" 
                            appendTo="body" [scrollHeight]="'250px'" [autoDisplayFirst]="false"
                            [autoZIndex]="true" [baseZIndex]="1000"></p-dropdown>
                    </ng-container>

                    <!-- User ID row -->
                    <ng-container *ngIf="row.type === 'user-id'">
                        <input type="text" [(ngModel)]="userId" (keydown.enter)="runReport()" class="user-id-input">
                    </ng-container>

                    <!-- Run Report row -->
                    <ng-container *ngIf="row.type === 'run-report'">
                        <p-button label="Run Report" class="btn-primary" (click)="runReport()"></p-button>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- TLR Health Details Layout - shown after Run Report is clicked -->
<div class="tlr-health-details-container" *ngIf="showResults">
    <h2>TLR Health Details</h2>
    
    <div class="criteria-section">
        <div class="criteria-header">
            <h3>Criterion</h3>
        </div>
        
        <p-table [value]="criteriaData" styleClass="criteria-table p-datatable-sm" [tableStyle]="{'margin-bottom':'20px'}">
            <ng-template pTemplate="body" let-criteria let-even="even">
                <tr [ngClass]="{'odd-row': !even, 'even-row': even}">
                    <td class="criteria-label">{{criteria.label}}:</td>
                    <td class="criteria-value">{{criteria.value}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr>
                    <td class="criteria-label">Row Count:</td>
                    <td class="criteria-value">{{reportResults ? reportResults.length : 0}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    
    <div class="actions">
        <p-button label="Back"  styleClass="cancel-btn" (click)="backToForm()"></p-button>
        <p-button label="Export to Excel" styleClass="btn-primary" (click)="exportToExcel()" [disabled]="!reportResults || reportResults.length === 0"></p-button>
    </div>
    
    <div class="results-section" *ngIf="reportResults && reportResults.length > 0">
        <p-table [value]="reportResults" styleClass="results-table" 
                [scrollable]="true" scrollHeight="400px" [paginator]="true"
                [rows]="10" [rowsPerPageOptions]="[10,25,50,100]">
            <ng-template pTemplate="header">
                <tr>
                    <th class="site-column">Site</th>
                    <th class="date-time-column">Date Time</th>
                    <th class="process-name-column">Process Name</th>
                    <th class="sub-process-column">Sub Process Name</th>
                    <th class="status-code-column">Status Code</th>
                    <th class="user-id-column">User ID</th>
                    <th class="comment-column">Comment</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-result>
                <tr>
                    <td class="site-column">{{result.site}}</td>
                    <td class="date-time-column">{{result.dateTime}}</td>
                    <td class="process-name-column">{{result.processName}}</td>
                    <td class="sub-process-column">{{result.subProcessName}}</td>
                    <td class="status-code-column">{{result.statusCode}}</td>
                    <td class="user-id-column">{{result.userId}}</td>
                    <td class="comment-column">{{result.comment}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    
    <div class="no-results" *ngIf="showResults && (!reportResults || reportResults.length === 0)">
        <p>No results found for the selected criteria.</p>
    </div>
</div>
